module.exports = __webpack_public_path__ + "assets/img/intro-vip-b1.83ef2904.jpg";